import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {useEffect} from 'react';
import {$getNodeByKey, $nodesOfType, $setSelection} from 'lexical';
import {RenderedFieldNode} from '../nodes/RenderedFieldNode';
import moment from 'moment';
import {calendarDate} from 'shared/tools';
import {formatCurrency, t} from 'shared/core';

function formatField(field) {
  let value = field.value;
  if (field.fieldType === 'date') {
    const date = moment(field.value);
    if (date.isValid()) {
      value = calendarDate(date);
    }
  } else if (field.fieldType === 'salary') {
    if (!field.value.payRate) {
      value = '';
    } else {
      const formattedPayRate = formatCurrency(field.value.payRateCurrency, field.value.payRate);
      const payRateUnit = ` ${t(`offers.editor.fields.per_unit.${field.value.payRateUnit}`)}`;
      value = `${formattedPayRate}${payRateUnit}`;
    }
  }
  return value || `<${field.label}>`;
}

function setNodeText(node, field) {
  const formattedValue = formatField(field);
  if (node.getTextContent() === formattedValue) return;
  $setSelection(null);
  node.setTextContent(formattedValue);
}

export default function RenderedFieldsPlugin({fields}) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerMutationListener(
      RenderedFieldNode,
      (mutatedNodes) => {
        editor.update(() => {
          for (let [nodeKey, mutation] of mutatedNodes) {
            if (mutation === 'created') {
              const node = $getNodeByKey(nodeKey);
              if (fields) {
                const field = fields.find(f => f.key === node.__dataKey);
                if (field) setNodeText(node, field);
              }
            }
          }
        });
      }
    );
  }, [editor]);

  useEffect(() => {
    if (!fields) return;
    editor.update(() => {
      $nodesOfType(RenderedFieldNode).forEach(node => {
        const field = fields.find(f => f.key === node.__dataKey);
        if (field) setNodeText(node, field);
      });
    });
  }, [fields]);

  return null;
}
